import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// CSS
import "./home-hero.css";
import { API_BASE_URL } from "../../config";

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 800,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: false,
  pauseOnHover: true,
  ltr: true,
};

// Slides are admin-managed now (see the Homepage Slider admin page) -
// used to be a hardcoded array here, so changing one (or the seasonal
// rotation of which show) meant a code change and redeploy.
const HomeHero = () => {
  const [slides, setSlides] = useState([]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/slide`)
      .then((res) => setSlides(res.data.slides || []))
      .catch((err) => console.error("Error fetching hero slides:", err));
  }, []);

  if (slides.length === 0) return null;

  return (
    <section className="home-hero">
      <Slider {...sliderSettings} className="home-hero-slider">
        {slides.map((slide) => (
          <div key={slide._id} className="home-hero-slide">
            <div className="home-hero-container">
              <div
                className="home-hero-img-container"
                style={{ backgroundImage: `url(${slide.image})` }}
              ></div>
              <div className="home-hero-text-container">
                <h1
                  className="font-display
                          uppercase
                          text-dark
                            font-[800]
                            tracking-tight
                            leading-tight
                            text-2xl
                            lg:text-3xl
                            2xl:text-4xl
                            mb-0
                            sm:mb-3
                            lg:mb-4
                            2xl:mb-5"
                >
                  Home delivery all day and night at Bashundhara
                </h1>
                <h1
                  className="
                            pb-2
                            text-accent
                            font-[900]
                            tracking-wider
                            leading-tight
                            text-2xl
                            lg:text-3xl
                            2xl:text-4xl"
                >
                  বসুন্ধরায় সারা দিন এবং রাতে হোম ডেলিভারি দেওয়া হয়
                </h1>
                <h1 className="home-hero-headline">{slide.headline}</h1>
                <h2 className="home-hero-subheadline">{slide.subheadline}</h2>
                <div className="home-hero-cta">
                  {!slide.category ? (
                    <>
                      <Link to="/menu" className="btn btn-primary">
                        {slide.buttonText}
                      </Link>
                      <a href="tel:+8801521494760" className="btn btn-secondary">
                        Call to Order
                      </a>
                    </>
                  ) : (
                    <>
                      <Link
                        to={`/menu?category=${encodeURIComponent(
                          slide.category
                        )}#full-menu`}
                        className="btn btn-primary"
                      >
                        {slide.buttonText}
                      </Link>
                      <Link to="/menu" className="btn btn-secondary">
                        Browse Menu
                      </Link>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default HomeHero;
